defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/ThemeDesign',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/ThemeDesignOptions'
  ],
  function (m, Ensighten, CtaButton, CardContent, ThemeDesignOptions) {
    // Context:
    var ThemeDesign = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.themeDesignDictionary = this.rootDictionary.get.bind({ prefix: 'CreateClub/Flow/ThemeDesign/' });

        this.helpOverlayTitle(this.themeDesignDictionary('HelpOverlay/Title'));
        this.helpOverlayDescription(this.themeDesignDictionary('HelpOverlay/Description'));

        this.flowTitle(this.themeDesignDictionary('Title'));
        this.flowDescription(this.themeDesignDictionary('Description'));
        this.property('flowGoBack', () => {
          this.currentStep('choseName');
          this.clubModel().save();
        });
        this.canEditClubName(false);

        setTimeout(() => {
          m.redraw();
        }, 0);

        Ensighten.pushGaEvent('spil_sammen', 'create_club', 'design_din_klub', null, true);
      },

      view: function (controller, ignoreArgs, { flowFooter }) {
        const footerContent = CtaButton({
          text: controller.themeDesignDictionary('SaveAndContinueButton'),
          onClick: () => {
            controller.clubModel().save();
            controller.currentStep('settings');
          },
          options: ['primary']
        });

        // Return:
        return CardContent({
          $content: m(ThemeDesignOptions, { controller: controller }),
          $footer: flowFooter(footerContent)
        });
      }
    };

    // Public functions:
    return ThemeDesign;
  });
